import { LogLevel, LogService } from "@/services/logging";
import AuthModule from "@/store/modules/auth";
import BookingModule from "@/store/modules/booking";
import CashFloatModule from "@/store/modules/cash-float";
import DeviceModule from "@/store/modules/device";
import FiskalyModule from "@/store/modules/fiskaly";
import {
  AccountingState,
  IAccounting,
  PaymentMethods,
  TransactionTypes,
} from "@/types/db/accounting";
import { IAccountingEntry } from "@/types/db/accounting-entry";
import { IProductSlotBooking } from "@/types/db/product-slot-booking";
import {
  BookingStatus,
  IProductSlotState,
} from "@/types/db/product-slot-state";
import { generateID } from "@/utils/helpers/app";
import { sumArray } from "@/utils/helpers/common";
import { resolveEndpoint } from "@/config/endpoint-resolver";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import { getTaxValue } from "@/utils/helpers/tax";
import { bookings, getpssExtension } from "@/utils/vue-helpers/booking";
import {
  excludedTaxByPss,
  pssUnpaidValue,
  restToPay,
} from "@/utils/vue-helpers/new-accountings";
import dayjs from "dayjs";
import {
  VoucherLib,
  VoucherService,
  OrderVoucherRedeemableValueInput,
  OrderVoucherRedeemableValueResponse,
  VoucherValidity,
  VoucherRedeemInput,
  VoucherStatusResponse,
} from "@smeetz/voucher";
import POSConfigModule from "@/store/modules/pos-config";
import { cloneDeep, sum } from "lodash";
import NotificationService from "@/services/notification.service";
import i18n from "@/lang";
// Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on t()
const t: (key: string, ...args: unknown[]) => string = (i18n.global as any).t;
import { Currencies } from "@/constants/currency";
import { IExternalVoucher } from "@/interfaces/store/IExternalVouchersState";
import ExternalVouchersModule from "@/store/modules/external-vouchers";
import { ref, watch } from "vue";
import { nowDB } from "@/utils/helpers/dates";

export interface IExternalVoucherCancellation {
  orderSessionRedeemableValue: number; // Expected to be always be negative
  orderRedeemableValue: number;
}

// /**
//  *
//  */
// export function prepareOrderData(
//   booking: IProductSlotBooking,
//   voucherCode: string
// ): OrderVoucherRedeemableValueInput {
//   let orderTotal = 0;
//   if (!booking || !booking.pssList || !booking.pssList.length) {
//     orderTotal = 0;
//   }
//   // We exclude cancelled pss
//   const notCancelledPssList = booking.pssList.filter(
//     (pss) =>
//       pss.bookingStatus !== BookingStatus.Canceled &&
//       pss.bookingStatus !== BookingStatus.Abandoned
//   );

//   const pssSum = sumArray(
//     notCancelledPssList.map(
//       (pss) =>
//         getPSSValue(pss) +
//         excludedTaxByPss.value(String(pss.uuid)) +
//         pss.paymentFeeCollected
//     )
//   );

//   orderTotal = pssSum;

//   // Discount Total
//   const discountAccountings =
//     booking.accountings.filter(
//       (acc) =>
//         ((acc.state === AccountingState.Pending && !acc.id) ||
//           (acc.state === AccountingState.Started && !acc.id) ||
//           acc.state === AccountingState.Completed) &&
//         acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT
//     ) || [];
//   const discountAccountingsEntries = discountAccountings
//     .map((acc) => acc.accountingEntriesList)
//     .flat();
//   const discountSum = sumArray(
//     discountAccountingsEntries.map((ae) => ae.value)
//   );

//   // Total Paid
//   const paymentAccountings =
//     booking.accountings.filter(
//       (acc) =>
//         ((acc.state === AccountingState.Pending &&
//           !acc.id &&
//           acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN) ||
//           (acc.state === AccountingState.Started &&
//             !acc.id &&
//             acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN) ||
//           acc.state === AccountingState.Completed) &&
//         (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT ||
//           acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND)
//     ) || [];
//   const paymentAccountingsEntries = paymentAccountings
//     .map((acc) => acc.accountingEntriesList)
//     .flat();
//   const paymentSum = sumArray(paymentAccountingsEntries.map((ae) => ae.value));

//   const orderData: OrderVoucherRedeemableValueInput = {
//     code: voucherCode,
//     currency: Currencies.EUR,
//     orderTotal: orderTotal, //1000,
//     totalPaymentValue: paymentSum,
//     discountsTotal: discountSum,
//     orderSessionId: String(BookingModule.currentOrderSessionId),
//   };
//   return orderData;
// }

/**
 *
 * @param code Status check call for the voucher
 * @returns
 */
export async function cancel(
  code: string
): Promise<IExternalVoucherCancellation> {
  // const response = await package.statusCheck();
  return {
    orderSessionRedeemableValue: -1000, // response.orderSessionRedeemableValue
    orderRedeemableValue: 1000, // response.orderRedeemableValue
  };
}

/**
 * Takes pssList and an redeemableValue object and create an accounting for the voucher
 */
export function createIncertVoucherAccounting(
  // orderData1: OrderVoucherRedeemableValueInput,
  voucherCode: string,
  redeemableValue: number,
  pssList: IProductSlotState[]
): IAccounting | undefined | null {
  console.log("hi from createIncertVoucherAccounting");
  if (redeemableValue <= 0) {
    return;
  }
  let voucherAmount = redeemableValue;
  const uuid = generateID();
  const creationTime = dayjs().toISOString();
  // link the transaction to the new accounting
  const transaction =
    FiskalyModule.transactionsInProgress[
      String(BookingModule.selectedBooking?.uuid)
    ];
  // Create accounting for the voucher
  const voucherAccounting: IAccounting = {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: AccountingState.Pending,
    transactionType: TransactionTypes.TRANSACTION_TYPE_PAYMENT,
    paymentMethod: PaymentMethods.EXTERNAL_INCERT_VOUCHER,
    bookingUuid: String(BookingModule.selectedBooking?.uuid),
    // promoCodeId: TODO Hamza: add voucher id here if there is any,
    // promoCodeUuid: TODO Hamza: add voucher id here if there is any,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: BookingModule.selectedBooking?.currency,
    accountingEntriesList: [],
    cashRegisterId: DeviceModule.cashRegisterId,
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    promocode: voucherCode,
    fiskalyTransactionUuid: transaction ? transaction.uuid : null,
    isExternalVoucherService: true,
  };
  console.log(
    "Incert Voucher accounting created, now creating accoutningEntry"
  );

  // Lets now create accounting entries for pss objects that get a payment from the voucher
  for (const pss of pssList) {
    if (
      pss.bookingStatus === BookingStatus.Canceled ||
      pss.bookingStatus === BookingStatus.Abandoned
    ) {
      // This pss is already paid ot cancelled, we will have no result from applying the voucher on this pss
      continue;
    }

    const entryCreationTime = dayjs().toISOString();
    const groupId = pss?.productOwnerGroupId || null;
    const productId = pss?.productId || null;
    const pssRemainingValue = pssUnpaidValue(pss);
    const accountingEntry: IAccountingEntry = {
      _id: generateID(),
      uuid: generateID(),
      accountingUuid: voucherAccounting.uuid,
      orderSessionId: String(BookingModule.currentOrderSessionId),
      productSlotStateUuid: pss.uuid,
      value: Math.min(voucherAmount, pssRemainingValue),
      groupId: groupId,
      bookingStatementVersion: 2,
      createdAt: entryCreationTime,
      updatedAt: entryCreationTime,
      productId: Number(productId),
    };
    if (pss && pss?.id) {
      accountingEntry.productSlotStateId = pss.id;
    }

    // new tax logic
    const priceTaxes = getpssExtension(String(pss?.uuid))?.taxes || [];
    if (priceTaxes.length) {
      const tax = priceTaxes[0];
      // We do not assign the field value for Payment transaction accountings
      // accountingEntry.salesTaxMicroValue = getTaxValue(
      //   accountingEntry.value,
      //   tax
      // );
      accountingEntry.salesTaxRate = Number(tax.rateMiliValue);
      accountingEntry.salesTaxIncluded = Number(tax.includedInPrice);
      accountingEntry.taxId = Number(tax.id);
    }
    voucherAccounting.accountingEntriesList.push(accountingEntry);
    // lets now update the voucher amount
    if (voucherAmount <= pssRemainingValue) {
      voucherAmount = 0;
      break;
    } else {
      voucherAmount = voucherAmount - pssRemainingValue;
    }
  }
  LogService.info(
    `Incert voucher accounting created, booking: ${pssList[0].bookingUuid}, accounting: ${voucherAccounting.uuid}`,
    {
      accounting: voucherAccounting,
    }
  );

  let accountingTotal = 0;
  const accountEntr = voucherAccounting.accountingEntriesList.map(
    (e) => e.value
  );
  accountingTotal = sum(accountEntr);
  if (!accountingTotal) return null;

  return voucherAccounting;
}

// /**
//  * Prepares order data needed by Voucher library and call the library to redeem the voucher
//  * @param voucherCode
//  */
// export async function prepareOrderDataAndRedeem(
//   voucherCode: string,
//   voucherLibObj: VoucherLib
// ) {
//   console.log("hi from prepareOrderDataAndRedeem");
//   try {
//     console.log("preparing orderData");
//     // 0- Prepare orderData for the library
//     const orderData: OrderVoucherRedeemableValueInput = prepareOrderData(
//       BookingModule.selectedBooking as IProductSlotBooking,
//       voucherCode
//     );

//     // 1- Redeem the voucher by calling the library
//     console.log("calling redeem function with below orderData");
//     console.log(orderData);
//     // const redemptionResult = await redeem(orderData);
//     const redemptionResult = await voucherLibObj.getOrderVoucherRedeemableValue(
//       orderData
//     );
//     console.log("redemptionResult:", redemptionResult);

//     if (redemptionResult.error) {
//       console.error(
//         "Failed to calculate redeemable value:",
//         redemptionResult.error
//       );
//       NotificationService.showCustomMessage(
//         t("Failed to calculate redeemable value"),
//         "error"
//       );
//       LogService.info(
//         `Incert Voucher Error: package failed to calculate redeemable value`,
//         { param: { redemptionResult } },
//         LogLevel.Error
//       );
//       return;
//     }

//     let redeemableValue = 0;
//     if (redemptionResult.data?.redeemableValue) {
//       redeemableValue = redemptionResult.data.redeemableValue * 100; // Smeetz count in cents whereas Incert count in EUR
//     } else {
//       console.log("This voucher cannot be applied to the current order");
//       NotificationService.showCustomMessage(
//         t("This voucher cannot be applied to the current order"),
//         "error"
//       );
//       LogService.info(
//         `Incert Voucher Error: This voucher cannot be applied to the current order`
//       );
//       return;
//     }

//     // console.log(`Maximum redeemable value: ${redemptionResult.data.redeemableValue} EUR`);

//     // 2- Create Voucher accountings, then show the usual notification
//     const pssList = BookingModule.selectedBooking?.pssList;
//     if (pssList && pssList.length) {
//       const bookingCopy = cloneDeep(
//         BookingModule.selectedBooking as IProductSlotBooking
//       );
//       const voucherAccounting = createIncertVoucherAccounting(
//         orderData,
//         redeemableValue,
//         pssList
//       );
//       if (
//         voucherAccounting &&
//         voucherAccounting.accountingEntriesList &&
//         voucherAccounting.accountingEntriesList.length
//       ) {
//         bookingCopy.accountings.push(voucherAccounting);
//       }
//       BookingModule.updateBooking(bookingCopy);
//     }

//     //Update current amount that will be shown in cash payment UI
//     BookingModule.addCurrentAmount({
//       BookingUUID: BookingModule.selectedBookingUUID,
//       amount: restToPay.value /*BookingModule.pssSumFinaValues*/ / 100,
//     });
//     BookingModule.setSplitPaymentAmount({
//       BookingUUID: BookingModule.selectedBookingUUID,
//       splitAmount: restToPay.value / 100 /*Math.min(
//           BookingModule.pssSumFinaValues / 100,
//           Math.abs(BookingModule.leftToPayAmount / 100)
//         )*/,
//     });
//   } catch (err: any) {
//     // TODO Hamza
//     // Show error notification based on library response for the user and log the error
//     LogService.info(
//       `Incert Voucher Error: no payment from generated from voucher`,
//       { param: { err } },
//       LogLevel.Error
//     );
//     NotificationService.showCustomMessage(
//       t("promocode.code-xxx-not-found"),
//       "error"
//     );
//   }
// }

/**
 *
 * @returns Initiate a VoucherLib instance
 */
export function initiateVoucherService(): VoucherLib {
  console.log("hi from initiateVoucherService");
  const groupId = POSConfigModule.groupId;
  console.log("groupId:", POSConfigModule.groupId);
  const voucherClient = new VoucherLib({
    apiUrl:
      resolveEndpoint("VITE_SERVICES_API") ||
      "https://services-live.smeetz.com",
    // service: VoucherService.INCERT,
    groupId: String(groupId), // '19434'
    orderSessionId: String(BookingModule.currentOrderSessionId),
    orderId: BookingModule.selectedBookingUUID,
  });

  return voucherClient;
}

/**
 * It calculates how much remainingValue the code still have and ask to create paymentAccounting accordingly
 * @param voucherInfo
 */
export function handleVoucherPayment(
  voucherInfo: IExternalVoucher,
  isAutoApplication?: boolean
) {
  console.log("------- hi from handleVoucherPayment");
  const pssList = BookingModule.selectedBooking?.pssList;
  if (pssList && pssList.length) {
    const bookingCopy = cloneDeep(
      BookingModule.selectedBooking as IProductSlotBooking
    );
    const redeemableValue = !voucherInfo.currentSessionVoucherConsumption
      ? voucherInfo.originalRemainingValue
      : voucherInfo.originalRemainingValue -
        voucherInfo.currentSessionVoucherConsumption;
    console.log("////// redeemableValue");
    console.log(redeemableValue);

    const pendingRefundVoucherAccountings = bookingCopy.accountings.filter(
      (acc) =>
        acc.refund &&
        acc.state === AccountingState.Pending &&
        acc.orderSessionId === BookingModule.currentOrderSessionId &&
        acc.promocode === voucherInfo.voucherCode
    );
    const pendingAccEntries = pendingRefundVoucherAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat()
      .map((acE) => acE.value);
    const sumOfPendingAccountingsVoucherRefund = sum(pendingAccEntries);

    const voucherAccounting = createIncertVoucherAccounting(
      voucherInfo.voucherCode,
      redeemableValue,
      pssList
    );
    if (
      voucherAccounting &&
      voucherAccounting.accountingEntriesList &&
      voucherAccounting.accountingEntriesList.length
    ) {
      bookingCopy.accountings.push(voucherAccounting);
    }
    BookingModule.updateBooking(bookingCopy);

    // Now lets update voucherInfo in the state to reflect the voucher consumptions we have just creating accountings for
    const voucherInfoCopy = cloneDeep(voucherInfo);
    voucherInfoCopy.currentSessionVoucherConsumption =
      voucherInfo.currentSessionVoucherConsumption +
      sum(voucherAccounting?.accountingEntriesList.map((ae) => ae.value));
    ExternalVouchersModule.updateExternalVoucher(voucherInfoCopy);
  }

  // If this voucher application is done right after applying the voucher then we need to update the amount track
  // eslint-disable-next-line no-constant-condition
  if (true /*!isAutoApplication*/) {
    //Update current amount that will be shown in cash payment UI
    BookingModule.addCurrentAmount({
      BookingUUID: BookingModule.selectedBookingUUID,
      amount: restToPay.value /*BookingModule.pssSumFinaValues*/ / 100,
    });
    BookingModule.setSplitPaymentAmount({
      BookingUUID: BookingModule.selectedBookingUUID,
      splitAmount: restToPay.value / 100 /*Math.min(
        BookingModule.pssSumFinaValues / 100,
        Math.abs(BookingModule.leftToPayAmount / 100)
      )*/,
    });
  }
}

/**
 * Removes all unpaid accountings of Incert voucher from the booking
 */
export function removeIncertVoucherPendingAccountings() {
  console.log("------ hi from removeIncertVoucherAccountings");
  // console.log("JSON.stringify(BookingModule.selectedBooking)");
  // console.log(JSON.stringify(BookingModule.selectedBooking));
  // console.log("JSON.stringify(BookingModule.selectedBooking?.accountings)");
  // console.log(JSON.stringify(BookingModule.selectedBooking?.accountings));
  const bookingCopy = cloneDeep(
    BookingModule.selectedBooking as IProductSlotBooking
  );
  // console.log("JSON.stringify(bookingCopy)");
  // console.log(JSON.stringify(bookingCopy.accountings));
  const incertAccountings = bookingCopy.accountings.filter(
    (acc) =>
      acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER &&
      acc.state === AccountingState.Pending &&
      !acc.refund
  );
  console.log("incertAccountings");
  console.log(incertAccountings);

  // Lets filter out incertAccountings from the booking
  incertAccountings.forEach((acc) => {
    bookingCopy.accountings = bookingCopy.accountings.filter(
      (a) => a.uuid !== acc.uuid
    );
  });
  console.log("incertAccountings");
  console.log(incertAccountings);

  // Now lets update voucherInfo in the state to reflect the voucher consumptions we have just removed their accountings
  console.log("incertAccountings.length");
  console.log(incertAccountings.length);
  incertAccountings.forEach((acc) => {
    const voucherInfo = ExternalVouchersModule.getExternalVouchers.find(
      (v) =>
        v.orderSessionId === acc.orderSessionId &&
        v.voucherCode === acc.promocode
    );
    if (voucherInfo) {
      // console.log(
      //   "voucherInfo after removing accounting before updating the state:",
      //   JSON.stringify(voucherInfo)
      // );
      const voucherInfoCopy = cloneDeep(voucherInfo);
      voucherInfoCopy.currentSessionVoucherConsumption =
        voucherInfo.currentSessionVoucherConsumption -
        sum(acc.accountingEntriesList.map((ae) => ae.value));
      // console.log("voucherInfoCopy:", JSON.stringify(voucherInfoCopy));
      ExternalVouchersModule.updateExternalVoucher(voucherInfoCopy);
    }
  });

  BookingModule.updateBooking(bookingCopy);
}

/**
 * Recreates accountings for all Incert vouchers applied during the current order session
 * It starts by removing all Incert pending accountings and then recreates them
 * This is called when user books more tickets or cancels tickets
 */
export function recreateIncertVoucherAccountings() {
  console.log("------ hi from recreateIncertVoucherAccountings");
  // console.log("JSON.stringify(BookingModule.selectedBooking)");
  // console.log(JSON.stringify(BookingModule.selectedBooking));
  // console.log("JSON.stringify(BookingModule.selectedBooking?.accountings)");
  // console.log(JSON.stringify(BookingModule.selectedBooking?.accountings));
  // Lets get a list of all Incert vouchers applied during the current order session that are still available to apply
  const incertVouchers = ExternalVouchersModule.getExternalVouchers.filter(
    (v) =>
      v.orderSessionId === String(BookingModule.currentOrderSessionId) &&
      v.originalRemainingValue > 0 &&
      v.status === VoucherValidity.Valid
  );
  console.log("incertVouchers:", incertVouchers);
  // Lets remove all pending Incert voucher accountings
  removeIncertVoucherPendingAccountings();

  // Now for each Incert voucher we will create accountings
  incertVouchers.forEach((voucher) => {
    handleVoucherPayment(voucher, true);

    // Now if sum of confirmed voucher payment and pending voucher payment is greater than the pssSum (excluding cancelled tickets) then we should create refund accounting for cancelled pss
    const vouchersAccountings =
      BookingModule.selectedBooking?.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Completed ||
            (!acc.id && acc.state === AccountingState.Pending)) &&
          acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER &&
          acc.promocode === voucher.voucherCode
      );
    let vouchersPaidTotal = 0;
    if (vouchersAccountings && vouchersAccountings.length) {
      vouchersPaidTotal = sum(
        vouchersAccountings
          .map((acc) => acc.accountingEntriesList)
          .flat()
          .map((acE) => acE.value)
      );
    }

    // We exclude cancelled pss
    const notCancelledPssList = BookingModule.selectedBooking?.pssList.filter(
      (pss) =>
        pss.bookingStatus !== BookingStatus.Canceled &&
        pss.bookingStatus !== BookingStatus.Abandoned
    );

    let pssSum = 0;
    if (notCancelledPssList && notCancelledPssList.length) {
      pssSum = Math.round(
        sumArray(
          notCancelledPssList.map(
            (pss) =>
              getPSSValue(pss) +
              excludedTaxByPss.value(String(pss.uuid)) +
              pss.paymentFeeCollected
          )
        )
      );
    }

    if (vouchersPaidTotal > pssSum) {
      // So we have more coucher payment then what we have in the order
      // lets take the difference and create refund accounting for it

      // lets get one cancelled pss paid by voucher
      const confirmedVoucherAccountings =
        BookingModule.selectedBooking?.accountings.filter(
          (acc) =>
            acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER &&
            acc.state === AccountingState.Completed &&
            acc.id &&
            acc.promocode === voucher.voucherCode &&
            !acc.refund
        );
      if (confirmedVoucherAccountings && confirmedVoucherAccountings?.length) {
        const confirmedVoucherAccountingEntries = confirmedVoucherAccountings
          ?.map((ac) => ac.accountingEntriesList)
          .flat();
        const cancelledPSS = BookingModule.selectedBooking?.pssList.find(
          (pss) =>
            pss.bookingStatus === BookingStatus.Canceled &&
            confirmedVoucherAccountingEntries
              ?.map((acE) => acE.productSlotStateUuid)
              .includes(pss.uuid)
        );
        const refundAccountingForDifference =
          createRefundAccountingForDifference(
            pssSum - vouchersPaidTotal,
            cancelledPSS as IProductSlotState,
            confirmedVoucherAccountings[0],
            voucher.voucherCode
          );
        const bookingCopy = cloneDeep(
          BookingModule.selectedBooking as IProductSlotBooking
        );
        bookingCopy?.accountings.push(refundAccountingForDifference);
        BookingModule.updateBooking(bookingCopy);
      }
    }
  });
}

/**
 * Check the booking accountings and prepare a list of payloads to supply to Lib.redeemVoucher()
 */
export function prepareVoucherRedemptionCallPayloads(): VoucherRedeemInput[] {
  console.log("------ hi from prepareVoucherRedemptionCallPayloads");
  const payloads: VoucherRedeemInput[] = [];

  const externalVoucherPendingPaymentAccounting: IAccounting[] = [];
  const booking = BookingModule.selectedBooking;
  if (booking && booking.accountings && booking.accountings.length > 0) {
    booking.accountings.forEach((acc) => {
      if (
        !acc.id &&
        !acc.refund &&
        (acc.isExternalVoucherService ||
          acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER)
      ) {
        if (
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
          acc.state === AccountingState.Pending
        ) {
          externalVoucherPendingPaymentAccounting.push(acc);
        }
      }
    });
  }

  // Now lets group accountings by voucher code
  let voucherCodes: string[] = [];

  if (externalVoucherPendingPaymentAccounting.length) {
    voucherCodes = [
      ...new Set(
        externalVoucherPendingPaymentAccounting.map((acc) =>
          String(acc.promocode)
        )
      ),
    ];

    console.log("------ voucherCodes");
    console.log(voucherCodes);

    // Now for each voucher code we will create a payload
    voucherCodes.forEach((voucherCode) => {
      const voucherAccountings = externalVoucherPendingPaymentAccounting.filter(
        (acc) => acc.promocode === voucherCode
      );
      const orderSessionId = voucherAccountings[0].orderSessionId;
      const value = sum(
        voucherAccountings.map((acc) =>
          sum(acc.accountingEntriesList.map((ae) => ae.value))
        )
      );
      payloads.push({
        code: voucherCode,
        value: value / 100,
        currency: "EUR",
        orderSessionId: orderSessionId,
        service: VoucherService.INCERT,
        groupId: String(POSConfigModule.groupId),
      });
    });
  }

  console.log("------ payloads");
  console.log(payloads);

  return payloads;
}

/**
 * Foreach payload, call the library to redeem
 */
export async function confirmRedemption(
  payloads: VoucherRedeemInput[]
): Promise<{ code: string; orderSessionId: string }[]> {
  console.log("------ hi from confirmRedemption");
  const voucherToConfirmAccountings: {
    code: string;
    orderSessionId: string;
  }[] = [];
  const voucherLibObj = initiateVoucherService();
  // console.log("voucherLibObj");
  // console.log(voucherLibObj);
  for (let i = 0; i < payloads.length; i++) {
    try {
      const response = await voucherLibObj.redeemVoucher(payloads[i]);
      // console.log("response");
      // console.log(response);
      if (response.error) {
        console.error("Failed to redeem voucher:", response.error);
        // NotificationService.showCustomMessage(
        //   t("Failed to redeem voucher"),
        //   "error"
        // );
        LogService.info(
          `Incert Voucher Error: package failed to redeem voucher`,
          { param: { response } },
          LogLevel.Error
        );
        console.log("returning false 1");
        // throw response.error;
      }
      // setTimeout(() => {
      //   // do nothing
      // }, 1000);
      // console.log("preparing voucherDataToConfirmAccounting");
      const voucherDataToConfirmAccounsting = {
        code: payloads[i].code,
        orderSessionId: String(payloads[i].orderSessionId),
      };
      // console.log("voucherDataToConfirmAccounsting");
      // console.log(voucherDataToConfirmAccounsting);
      voucherToConfirmAccountings.push(voucherDataToConfirmAccounsting);
      // console.log("voucherToConfirmAccountings");
      // console.log(voucherToConfirmAccountings);
    } catch (error) {
      console.log("hi from catch");
      console.log("Failed to redeem voucher:", error);
      // NotificationService.showCustomMessage(
      //   t("Failed to redeem voucher"),
      //   "error"
      // );
      LogService.info(
        `Incert Voucher Error: package failed to redeem voucher`,
        { param: { error } },
        LogLevel.Error
      );
      // throw error;
    }
  }
  // payloads.forEach(async (payload) => {
  //   console.log("payload");
  //   console.log(payload);
  //   try {
  //     const response = await voucherLibObj.redeemVoucher(payload);
  //     console.log("response");
  //     console.log(response);
  //     if (response.error) {
  //       console.error("Failed to redeem voucher:", response.error);
  //       // NotificationService.showCustomMessage(
  //       //   t("Failed to redeem voucher"),
  //       //   "error"
  //       // );
  //       LogService.info(
  //         `Incert Voucher Error: package failed to redeem voucher`,
  //         { param: { response } },
  //         LogLevel.Error
  //       );
  //       console.log("returning false 1");
  //       // throw response.error;
  //     }
  //     setTimeout(() => {
  //       // do nothing
  //     }, 1000);
  //     console.log("preparing voucherDataToConfirmAccounting");
  //     const voucherDataToConfirmAccounting = {
  //       code: payload.code,
  //       orderSessionId: String(payload.orderSessionId),
  //     };
  //     console.log("voucherDataToConfirmAccounting");
  //     console.log(voucherDataToConfirmAccounting);
  //     voucherToConfirmAccountings.push(voucherDataToConfirmAccounting);
  //     console.log("voucherToConfirmAccountings");
  //     console.log(voucherToConfirmAccountings);
  //   } catch (error) {
  //     console.log("hi from catch");
  //     console.log("Failed to redeem voucher:", error);
  //     // NotificationService.showCustomMessage(
  //     //   t("Failed to redeem voucher"),
  //     //   "error"
  //     // );
  //     LogService.info(
  //       `Incert Voucher Error: package failed to redeem voucher`,
  //       { param: { error } },
  //       LogLevel.Error
  //     );
  //     // throw error;
  //   }
  // });
  console.log("returning");
  console.log(voucherToConfirmAccountings);
  return voucherToConfirmAccountings;
}

/**
 *
 * Takes a pulled order and checks whether is has external vouchers completed accountings
 */
export function hasAppliedAndCompletedExternalVouchers(
  pulledOrder: IProductSlotBooking
) {
  const has = pulledOrder.accountings.find(
    (acc) =>
      acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER &&
      acc.state === AccountingState.Completed
  );
  if (has) {
    return true;
  }
  return false;
}

/**
 * Called after pulling an order to edit it
 * It will call external voucher library statusCheck for each voucher in the order
 * and set them in ExternalVouchersModule so that when user book new tickets we try to auto-apply them
 *
 */
export async function editOrderExternalVoucherInfoConstruction(
  order: IProductSlotBooking,
  voucherLibObj?: VoucherLib
) {
  // 1- Get all applied external vouchers
  let alreadyAppliedExternalVouchers = order.accountings
    .filter(
      (acc) =>
        acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER &&
        acc.state === AccountingState.Completed
    )
    .map((acc) => {
      // if this edit order is by pulling from orders table then we use acc.note because backend use it to store external voucher
      if (acc.id) {
        return acc.note;
      } else {
        return acc.promocode;
      }
    });

  alreadyAppliedExternalVouchers = [...new Set(alreadyAppliedExternalVouchers)];

  console.log(
    "alreadyAppliedExternalVouchers:",
    alreadyAppliedExternalVouchers
  );
  LogService.info(
    "External Voucher: calling statusCheck for attached external vouchers",
    {
      params: alreadyAppliedExternalVouchers,
    }
  );

  // 2- Do a statusCheck for each voucher
  if (!voucherLibObj) {
    voucherLibObj = await initiateVoucherService();
  }
  for (let i = 0; i < alreadyAppliedExternalVouchers.length; i++) {
    let respData: VoucherStatusResponse | null | undefined;
    try {
      const resp = await voucherLibObj.getVoucherStatus({
        service: VoucherService.INCERT,
        code: String(alreadyAppliedExternalVouchers[i]),
      });
      respData = resp.data;
    } catch (err) {
      console.log("hi from catch");
      console.log(err);
      LogService.info(
        "Incert Voucher Error: when pulling edit",
        {
          params: err,
        },
        LogLevel.Error
      );
      // NotificationService.showCustomError("Could not get vouchers info");
      NotificationService.showCustomError(t("error.no-internet"));
      // Lets log this error and show that this voucher code and return
      return;
      // // Hard coded response
      // respData = {
      //   status: 1,
      //   remainingValue: 87199,
      //   partiallyRedeemable: true,
      //   currency: "EUR",
      // };
    }

    console.log("respData:", respData);

    // 3- Set voucherInfo in ExternalVoucherModule for each voucher

    // Lets now store the voucher info in ExternalVouchersModule
    const statusName =
      VoucherValidity[
        Number(respData?.status) as unknown as keyof typeof VoucherValidity
      ];
    const voucherInfo: IExternalVoucher = {
      voucherCode: String(alreadyAppliedExternalVouchers[i]),
      status: Number(respData?.status),
      // Now we set statusName based on VoucherValidity enum
      statusName: String(statusName),
      originalRemainingValue: Number(respData?.remainingValue) * 100, // Because Smeetz count in cents whereas Incert count in EUR
      partiallyRedeemable: respData?.partiallyRedeemable as boolean,
      currency: Currencies.EUR,
      orderSessionId: String(BookingModule.currentOrderSessionId),
      currentSessionVoucherConsumption: 0, // Current session voucher consumption
      voucherService: VoucherService.INCERT,
    };
    ExternalVouchersModule.addExternalVouchers(voucherInfo);
    LogService.info("Incert Voucher info added to the module", {
      params: voucherInfo,
    });
  }
}

/**
 * Creates Incert Refund Accountings
 */
export function createCancelPSSRefundIncertAccounting(
  booking: IProductSlotBooking,
  pss: IProductSlotState,
  accounting: IAccounting
): IAccounting | null | undefined {
  console.log("§§§§§§ hi from createCancelPSSRefundIncertAccounting");
  LogService.info(
    `Going to create refund incert accounting for attached pss: ${pss.uuid}, booking: ${booking.uuid}`,
    {
      params: pss,
    }
  );

  const uuid = generateID();
  const creationTime = dayjs().toISOString();
  const accountingState = AccountingState.Pending; // Extrnal vouchers refund accountings shouldn't be completed until the user tries to confirm the booking and we do a refund call
  const transactionType = TransactionTypes.TRANSACTION_TYPE_PAYMENT;
  const paymentMethod = accounting.paymentMethod;
  const promocode = accounting.promocode;

  const refundAccounting: IAccounting = {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: accountingState,
    transactionType: transactionType,
    paymentMethod: paymentMethod,
    bookingUuid: booking.uuid,
    promoCodeUuid: promocode,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: booking.currency,
    accountingEntriesList: [],
    cashRegisterId: DeviceModule.cashRegisterId,
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    promocode: promocode,
    refund: 1,
  };

  const now = nowDB();
  const correspondingPaymentAccEntry = accounting.accountingEntriesList.find(
    (ae) => ae.productSlotStateUuid === pss.uuid
  );
  let refundValue = 0;
  if (correspondingPaymentAccEntry) {
    refundValue = -1 * correspondingPaymentAccEntry.value;
  }
  const accountingEntry: IAccountingEntry = {
    _id: generateID(),
    uuid: generateID(),
    accountingUuid: refundAccounting.uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    productSlotStateUuid: pss.uuid,
    value: refundValue,
    groupId: Number(pss.productOwnerGroupId),
    bookingStatementVersion: 2,
    createdAt: now,
    updatedAt: now,
    productId: pss.productId,
  };

  if (correspondingPaymentAccEntry?.salesTaxMicroValue) {
    accountingEntry.salesTaxMicroValue =
      -1 * correspondingPaymentAccEntry.salesTaxMicroValue;
    accountingEntry.salesTaxIncluded =
      correspondingPaymentAccEntry.salesTaxIncluded;
    accountingEntry.salesTaxRate = correspondingPaymentAccEntry.salesTaxRate;
    accountingEntry.taxId = correspondingPaymentAccEntry.taxId;
  }

  if (pss && pss.id) {
    accountingEntry.productSlotStateId = pss.id;
  }
  refundAccounting.accountingEntriesList.push(accountingEntry);
  /////////////////////////
  LogService.info(
    `Done creating refund incert accounting for the pss ${pss.uuid}`,
    {
      params: refundAccounting,
    }
  );
  return refundAccounting;
}

/**
 * Returns whether or not has cancelled tickets paid with external vouchers
 * Used to decide whether we Redeem or we Refund the external vouchers
 */
export function hasCancelledTicketsPaidWithExternalVoucher(): boolean {
  console.log("hi from hasCancelledTicketsPaidWithExternalVoucher");
  const cancelledTickets: IProductSlotState[] | undefined =
    BookingModule.selectedBooking?.pssList.filter(
      (ps) => ps.bookingStatus === BookingStatus.Canceled
    );
  console.log("cancelledTickets");
  console.log(cancelledTickets);

  if (cancelledTickets && cancelledTickets.length) {
    // Lets check if these cancelled tickets are paid fully/partially with external vouchers
    const externalVoucherAccountings =
      BookingModule.selectedBooking?.accountings.filter(
        (acc) =>
          acc.state === AccountingState.Completed &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
          (acc.isExternalVoucherService ||
            acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER)
      );
    const accEntries: IAccountingEntry[] = [];
    if (externalVoucherAccountings && externalVoucherAccountings.length) {
      externalVoucherAccountings.forEach((acc) => {
        acc.accountingEntriesList.forEach((entry) => accEntries.push(entry));
      });
    }
    console.log("externalVoucherAccountings");
    console.log(externalVoucherAccountings);

    const pssUuidsPaidWithExternalVouchers: string[] = accEntries.map(
      (accEntry) => String(accEntry.productSlotStateUuid)
    );
    console.log("pssUuidsPaidWithExternalVouchers");
    console.log(pssUuidsPaidWithExternalVouchers);
    for (let i = 0; i < cancelledTickets.length; i++) {
      if (
        pssUuidsPaidWithExternalVouchers.includes(
          String(cancelledTickets[i].uuid)
        )
      ) {
        // So there is at least one cancelled ticket paid with external vouchers
        console.log("true");
        return true;
      }
    }
  }

  console.log("returning false");

  return false;
}

export function createRefundAccountingForDifference(
  diff: number,
  cancelledPss: IProductSlotState,
  accounting: IAccounting,
  voucherCode: string
) {
  const uuid = generateID();
  const creationTime = dayjs().toISOString();
  const accountingState = AccountingState.Pending; // Extrnal vouchers refund accountings shouldn't be completed until the user tries to confirm the booking and we do a refund call
  const transactionType = TransactionTypes.TRANSACTION_TYPE_PAYMENT;
  const promocode = voucherCode;

  const correspondingPaymentAccEntry = accounting.accountingEntriesList.find(
    (ae) => ae.productSlotStateUuid === cancelledPss.uuid
  );

  const refundAccounting: IAccounting = {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: accountingState,
    transactionType: transactionType,
    paymentMethod: accounting.paymentMethod,
    bookingUuid: BookingModule.selectedBookingUUID,
    promoCodeUuid: promocode,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: BookingModule.selectedBooking?.currency,
    accountingEntriesList: [],
    cashRegisterId: DeviceModule.cashRegisterId,
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    promocode: promocode,
    refund: 1,
  };

  const now = nowDB();
  const refundValue = diff;
  const accountingEntry: IAccountingEntry = {
    _id: generateID(),
    uuid: generateID(),
    accountingUuid: refundAccounting.uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    productSlotStateUuid: cancelledPss.uuid,
    value: refundValue,
    groupId: Number(cancelledPss.productOwnerGroupId),
    bookingStatementVersion: 2,
    createdAt: now,
    updatedAt: now,
    productId: cancelledPss.productId,
  };

  if (correspondingPaymentAccEntry?.salesTaxMicroValue) {
    accountingEntry.salesTaxMicroValue =
      -1 * correspondingPaymentAccEntry.salesTaxMicroValue;
    accountingEntry.salesTaxIncluded =
      correspondingPaymentAccEntry.salesTaxIncluded;
    accountingEntry.salesTaxRate = correspondingPaymentAccEntry.salesTaxRate;
    accountingEntry.taxId = correspondingPaymentAccEntry.taxId;
  }

  if (cancelledPss && cancelledPss.id) {
    accountingEntry.productSlotStateId = cancelledPss.id;
  }
  refundAccounting.accountingEntriesList.push(accountingEntry);
  return refundAccounting;
}
